<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Auleie/tc-custom/9781780108155.jpg?1728259273699" alt="This image is the cover for the book Good Time Coming"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Good Time Coming
      </h1>
      <p class="bookDescription body article font2">
        <b>A girl grows up too quickly in Civil War Louisiana: “Powerful…This is top-notch historical fiction.”—<i>Publishers Weekly</i></b><br/><br/><i>I killed a man the summer I turned thirteen…</i><br/><br/> Thus begins <i>USA Today</i>-bestselling author C. S. Harris’s haunting, lyrically beautiful tale of coming of age in Civil War-torn Louisiana. Eleven-year-old Amrie St. Pierre is catching tadpoles with her friend Finn O’Reilly when the Federal fleet first steams up the Mississippi River in the spring of 1862. With the surrender of New Orleans, Amrie’s sleepy little village of St. Francisville—strategically located between the last river outposts of Vicksburg and Port Hudson—is now frighteningly vulnerable. As the roar of cannons inches ever closer and food, shoes, and life-giving medicines become increasingly scarce, Amrie is forced to grow up fast. But it is her own fateful encounter with a tall, golden-haired Union captain named Gabriel that threatens to destroy everything and everyone she holds most dear.<br/><br/> Told with rare compassion and insight, this is a story of loss and survival; of the bonds that form among women and children left alone to face the hardships, depravations, and dangers of war; and of one unforgettable girl’s slow and painful recognition of the good and evil that exists within us all.<br/>  <br/> “This story of love, loss, and growing up under some of the most difficult circumstances imaginable is beautifully written, superbly researched, emotionally engaging and gripping from first page to last. A must for old-school fans of historical fiction.”—<i>Booklist </i>(starred review
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        C.S. Harris
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?666b8456